import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { Table } from "@opensea/ui-kit"
import type { TransferFlowFormValues } from "../../types"
import { TransferFlowReviewItem } from "./TransferFlowReviewItem"
import { TransferFlowReviewItemsFragment } from "./TransferFlowReviewItems.fragment"

type Props = {
  items: FragmentOf<typeof TransferFlowReviewItemsFragment>[]
  formValues: TransferFlowFormValues
}

export const TransferFlowReviewItems = ({
  items: itemKeys,
  formValues,
}: Props) => {
  const items = itemKeys.map(itemKey =>
    readFragment(TransferFlowReviewItemsFragment, itemKey),
  )
  const tableItems = formValues.items.flatMap(formItem => {
    const matchedItem = items.find(item => item.id === formItem.id)

    return matchedItem ? [matchedItem] : []
  })

  return (
    <Table
      itemKey={(_, index) => index}
      items={tableItems}
      renderRow={TransferFlowReviewItem}
      size="lg"
    />
  )
}
